import {
  ChangeDetectionStrategy,
  Component,
  SecurityContext,
  effect,
  inject,
  signal,
} from '@angular/core';
import { FormControl, ReactiveFormsModule, Validators } from '@angular/forms';
import { DomSanitizer } from '@angular/platform-browser';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import {
  ModalAction,
  ModalStep,
} from '@shared/components/hub-entity-action-modal/hub-entity-action-modal';
import { HubInputFormControlModule } from '../hub-input-form-control/hub-input-form-control.module';

@Component({
  templateUrl: './hub-entity-action-modal.component.html',
  styleUrls: ['./hub-entity-action-modal.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [ReactiveFormsModule, HubInputFormControlModule],
})
export class HubEntityActionModalComponent {
  private activeModal = inject(NgbActiveModal);
  private domSanitizer = inject(DomSanitizer);

  readonly steps = signal<ModalStep[]>([]);
  readonly stopPropagation = signal(true);
  /**
   * if true will be shown field where user need to type "DELETE" to confirm the action
   */
  readonly deleteDoubleConfirmation = signal(false);
  readonly confirmationControl = new FormControl<string>('', { nonNullable: true });
  readonly modalAction = ModalAction;
  readonly stepIndex = signal(0);

  readonly validationMessages = {
    required: `Please type "DELETE" to confirm the action`,
    pattern: `Please type "DELETE" to confirm the action`,
  };

  constructor() {
    effect(() => {
      if (this.deleteDoubleConfirmation()) {
        this.confirmationControl.addValidators([Validators.required, Validators.pattern('DELETE')]);
      } else {
        this.confirmationControl.removeValidators([
          Validators.required,
          Validators.pattern('DELETE'),
        ]);
      }
      this.confirmationControl.updateValueAndValidity();
    });
  }

  onActionBtnClick(event: Event, action: ModalAction): void {
    if (this.stopPropagation()) {
      event.stopPropagation();
    }

    switch (action) {
      case ModalAction.cancel: {
        this.onClose();
        break;
      }

      case ModalAction.nextStep: {
        if (this.stepIndex() + 1 <= this.steps().length) {
          this.stepIndex.update((v) => v + 1);
        }
        break;
      }

      case ModalAction.apply: {
        this.onClose(true);
        break;
      }

      case ModalAction.merge: {
        this.onClose(ModalAction.merge);
        break;
      }
    }
  }

  sanitize(text: string): string {
    return this.domSanitizer.sanitize(SecurityContext.HTML, text) || '';
  }

  private onClose(applyActionOnEntity: ModalAction | boolean = false): void {
    this.activeModal.close(applyActionOnEntity);
  }
}
